import { useState, useEffect } from 'react';

const BREAKPOINTS = { mobile: 0, tablet: 768, desktop: 1024 };

function getBreakpoint(width) {
  if (width >= BREAKPOINTS.desktop) return 'desktop';
  if (width >= BREAKPOINTS.tablet) return 'tablet';
  return 'mobile';
}

export function useBreakpoint() {
  const [bp, setBp] = useState(() => getBreakpoint(window.innerWidth));

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const handler = () => setBp(getBreakpoint(window.innerWidth));
    // Listen on the coarser tablet boundary; desktop changes are caught too
    // because innerWidth is re-read on every change event.
    const mql = window.matchMedia('(min-width: 768px)');
    mql.addEventListener('change', handler);
    // Also listen for the desktop breakpoint crossing
    const mqlDesktop = window.matchMedia('(min-width: 1024px)');
    mqlDesktop.addEventListener('change', handler);
    return () => {
      mql.removeEventListener('change', handler);
      mqlDesktop.removeEventListener('change', handler);
    };
  }, []);

  return {
    breakpoint: bp,
    isMobile: bp === 'mobile',
    isTablet: bp === 'tablet',
    isDesktop: bp === 'desktop',
    isTabletOrDesktop: bp !== 'mobile',
  };
}
